import type { AxiosError, AxiosRequestConfig } from 'axios';

import Axios from 'axios';
import Constants from 'expo-constants';

import { setupAxiosInterceptors } from '@goodneighbor/auth';

const apiAxiosInstance = Axios.create({
  paramsSerializer: { indexes: null },
  baseURL:
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    process.env.NEXT_PUBLIC_SDK_BASE_URL ||
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    process.env.EXPO_PUBLIC_SDK_BASE_URL ||
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    process.env.SDK_BASE_URL
});

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
if (process.env.NODE_ENV === 'development') {
  apiAxiosInstance.interceptors.request.use((config) => {
    const fullUrl = config.baseURL ? config.baseURL + config.url : config.url;
    // eslint-disable-next-line no-console
    console.log(
      'Custom Axios API Request:',
      config.method?.toUpperCase(),
      fullUrl
    );
    return config;
  });
}

setupAxiosInterceptors({
  axiosInstance: apiAxiosInstance,
  shouldAutoLogoutOnFailedSessionRefresh: true,
  isAuthServer: false
});

// add a second `options` argument here if you want to pass extra options to each generated query
const customAxios = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig
): Promise<T> =>
  apiAxiosInstance
    .request({
      ...config,
      headers: {
        ...config.headers,
        'X-App-Version': Constants.expoConfig?.version,
        ...(process.env['EXPO_PUBLIC_ENV'] === 'qa'
          ? { 'x-api-key': process.env['EXPO_PUBLIC_API_KEYS'] }
          : {})
      },
      ...options
    })
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });

export { customAxios };
export type ErrorType<Error> = AxiosError<Error>;
